import { X } from 'lucide-react'
import React, { MouseEvent } from 'react'
import { cn } from 'src/lib/utils'

export interface SeriesCardDismissSeriesButtonProps {
  onDismissClick: (e: MouseEvent<HTMLButtonElement>) => void
  ariaLabel?: string
  disabled?: boolean
  className?: string
  'data-testid'?: string
}

export const SeriesCardDismissSeriesButton = ({
  onDismissClick,
  ariaLabel = 'Dismiss series',
  disabled,
  className,
  'data-testid': dataTestId,
}: SeriesCardDismissSeriesButtonProps): React.ReactElement => (
  <button
    type="button"
    data-testid={dataTestId}
    disabled={disabled}
    className={cn(
      'z-20 rounded-full border w-4 h-4 flex items-center justify-center text-ivory hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-ivory',
      'disabled:pointer-events-none disabled:opacity-50',
      className,
    )}
    aria-label={ariaLabel}
    onClick={(e) => {
      onDismissClick(e)
    }}
  >
    <X className="w-3 h-3" strokeWidth={1.5} />
  </button>
)
